module.exports = __webpack_public_path__ + "img/img-huzhao.e5a59c8b.jpg";